module.exports = __webpack_public_path__ + "img/verify2.836ca054.png";